import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { formPageReducer } from './formPageReducer';
import { apiPageReducer } from './apiPageReducer';

export const store = configureStore({
  reducer: {
    apiPage: apiPageReducer,
    formPage: formPageReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
